export const showWebToAppBanner = () => {
    if (typeof window.AF === "function") {
        window.AF("banners", "showBanner");
    }
};

export const hideWebToAppBanner = () => {
    if (typeof window.AF === "function") {
        window?.AF("banners", "hideBanner");
    }
};
